import { useCallback } from 'react'
import type { ApolloError } from '@truepill/tpos-react-router'
import AdjustmentValidationFailedModal from 'modals/AdjustmentValidationFailedModal'
import { useModalContext } from 'providers/Overlays/ModalProvider'

// must match ADJUSTMENT_VALIDATION_FAILED_CODE in @truepill/tpos-data
export const ADJUSTMENT_VALIDATION_FAILED_CODE = 'ADJUSTMENT_VALIDATION_FAILED'

/**
 * Returns a handler for mutation errors: when the backend blocked an inventory decrement because Tecsys can't cover
 * it, the handler shows the validation modal and returns true. Otherwise it returns false so the caller can fall back
 * to its usual error handling.
 */
const useAdjustmentValidationErrorHandler = (): ((error: unknown) => boolean) => {
  const { showModal } = useModalContext()

  return useCallback(
    (error: unknown) => {
      const validationError = (error as ApolloError | undefined)?.graphQLErrors?.find(
        graphQLError => graphQLError.extensions?.code === ADJUSTMENT_VALIDATION_FAILED_CODE,
      )
      if (!validationError) return false

      const messages = (validationError.extensions?.messages as string[] | undefined) ?? [validationError.message]
      showModal(() => <AdjustmentValidationFailedModal messages={messages} />)
      return true
    },
    [showModal],
  )
}

export default useAdjustmentValidationErrorHandler
